export default "<div class=\"academondo-chatbot-container\">\r\n  <flowise-fullchatbot></flowise-fullchatbot>\r\n</div>\r\n"